import moment from 'moment'

const currentLocale = localStorage.getItem(process.env.VUE_APP_LS_LOCALE_KEY) || process.env.VUE_APP_DEFAULT_LOCALE

export default {
  methods: {
    getFormatedDate(date) {
      if (typeof date === 'string') {
        return date
      }

      const { year, month, day, hour, min } = date
      const format = hour && min >= 0 ? 'YYYY. MMMM DD. HH:mm' : 'YYYY.MM.DD'
      const dateFormat = hour && min >= 0 ? `${year}/${month}/${day} ${hour}:${min}` : `${year}/${month}/${day}`

      return moment(new Date(dateFormat)).locale(currentLocale).format(format)
    }
  }
}
